"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ratio = _interopRequireDefault(require("../../../../../shapes/ratio.shape"));

const RatioIcon = props => {
  const {
    ratio
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "ratio-icon"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('ratio-icon__shape', "ratio-icon__shape--".concat(ratio))
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "ratio-icon__name"
  }, ratio));
};

RatioIcon.propTypes = {
  ratio: _ratio.default.isRequired
};
var _default = RatioIcon;
exports.default = _default;